import { Component, Input } from '@angular/core';
import { InteractionSummaryModel } from '../../services/ai.service';

@Component({
  selector: 'tangram-interaction-summary-card',
  templateUrl: './interaction-summary-card.component.html',
  styleUrls: ['./interaction-summary-card.component.scss']
})
export class InteractionSummaryCardComponent {
  @Input() summary: InteractionSummaryModel | null = null;
  @Input() loading: boolean = false;
  @Input() error: string = '';
}
